import Marionette from "backbone.marionette";
import $ from "jquery";
import moment from "moment-timezone";
import Clipboard from "clipboard";

import { validatePhone } from "lib/util";

import template from "../templates/components/referral.jst";
import modalTemplate from "../templates/components/modal.jst";
import events from "../events";

const ReferralView = Marionette.View.extend({
    getTemplate() {
        return this.options.template || template;
    },
    ui: {
        content: "[data-content]",
        copyBtn: ".js-copy",
        submitBtn: ".js-submit",
        submitText: ".js-submit span:first-child",
        successText: ".js-submit span:last-child",
        tab: "[data-tab]",
    },
    events: {
        "click @ui.tab": "onClickTab",
        "click @ui.submitBtn": "onSubmit",
    },
    initialize() {
        if (!("showFooter" in this.options)) {
            this.options.showFooter = true;
        }
    },
    serializeData() {
        let uid = window.uid || "";
        if (uid) {
            uid = `_${uid}`;
        }

        return {
            uid,
            header: this.options.header || "Know anyone job searching?",
            subheader: this.options.subheader || "Let them know about WorkStep!",
            campaign: this.options.campaign || "",
            pid: this.options.pid || "",
            url:
                this.options.url ||
                `${window.location.protocol}//${window.location.hostname}/jobs/welcome`,
            date: moment().format("YYMMDD"),
            showFooter: this.options.showFooter,
            loggedIn: window.authUser,
        };
    },
    getActiveTab() {
        return this.ui.tab.filter(".active");
    },
    getActiveTabName() {
        return this.getActiveTab().data("tab");
    },
    getActiveContent() {
        return this.ui.content.filter(`[data-content=${this.getActiveTabName()}]`);
    },
    onClickTab(event) {
        event.preventDefault();

        const $tab = $(event.currentTarget);
        this.ui.tab.removeClass("active error");
        $tab.addClass("active");

        this.ui.content.hide();
        this.getActiveContent().show();
    },
    onRender() {
        const $btn = this.ui.copyBtn;
        const clipboard = new Clipboard($btn[0]);
        clipboard.on("success", () => {
            events.track("REFERRAL_LINK_COPY", this.options.campaign);

            const ogText = $btn.text();
            $btn.text("Copied!");
            setTimeout(() => {
                $btn.text(ogText);
            }, 1000);
        });
    },
    onSubmit(event) {
        event.preventDefault();

        const tabName = this.getActiveTabName();
        const isPhone = tabName === "phone";

        const $textarea = this.getActiveContent().find("textarea");
        const text = $textarea.val();
        if (text.trim().length === 0) {
            this.getActiveTab().addClass("error");
            return;
        }

        let handles = text.split(",").map((handle) => handle.trim());
        if (isPhone) {
            handles = handles.map((handle) => {
                let phone = handle.replace(/\D/g, "");
                // Ignore '+1'
                if (phone.length === 11 && phone[0] === "1") {
                    phone = phone.substring(1);
                }
                return phone;
            });
        }

        const errors = handles
            .map((handle) => {
                if (isPhone) {
                    if (!validatePhone(handle)) {
                        return handle;
                    }
                } else if (handle.split("@").length !== 2 || handle.indexOf(".") === -1) {
                    return handle;
                }

                return null;
            })
            .filter((x) => x !== null);

        if (handles.length === 0 || errors.length > 0) {
            events.track("REFERRAL_MODAL_ERROR", isPhone ? "phone" : "email");

            this.getActiveTab().addClass("error");
            return;
        }

        this.ui.tab.removeClass("error");
        this.ui.submitBtn.loading(true);

        const data = {
            utm_campaign: $textarea.data("campaign"),
        };
        if (isPhone) {
            data.phones = handles;
        } else {
            data.emails = handles;
        }

        const self = this;
        $.ajax({
            url: "/api/hire/v1/referral/",
            method: "POST",
            data: JSON.stringify(data),
            dataType: "json",
            contentType: "application/json",
        })
            .done(() => {
                self.$("textarea").each((idx, el) => {
                    $(el).val("");
                });

                self.ui.submitText.fadeOut(100, () => {
                    self.ui.successText.fadeIn(250);
                    setTimeout(() => {
                        self.trigger("saved");
                        self.ui.successText.fadeOut(100, () => {
                            self.ui.submitText.fadeIn(250);
                        });
                    }, 1250);
                });
            })
            .always(() => {
                self.ui.submitBtn.loading(false);
            });
    },
});

const ReferralModal = Marionette.View.extend({
    el: "#referral-modal",
    template: modalTemplate,
    ui: {
        content: ".modal-content",
    },
    showError(msg) {
        this.ui.form.addClass("has-error");
        this.ui.error.text(msg);
    },
    onRender() {
        this.view = new ReferralView({
            el: this.ui.content,
            header: this.options.header,
            subheader: this.options.subheader,
            campaign: this.options.campaign,
            showFooter: false,
            showIcon: true,
            url: this.options.url,
            pid: this.options.pid,
        });
        this.view.render();
        this.listenTo(this.view, "saved finished", () => {
            $.modal.close();
        });

        this.$el.addClass("modal-full");
        this.$el.modal({
            closeClass: "icon-close",
            closeText: "&times;",
            fadeDuration: 350,
            fadeDelay: 0,
        });
    },
});

export default {
    Modal: ReferralModal,
    View: ReferralView,
};
